import { render, staticRenderFns } from "./protocolList.vue?vue&type=template&id=3005d030&scoped=true"
import script from "./protocolList.vue?vue&type=script&lang=ts"
export * from "./protocolList.vue?vue&type=script&lang=ts"
import style0 from "./protocolList.vue?vue&type=style&index=0&id=3005d030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005d030",
  null
  
)

export default component.exports